import React, { Component } from "react";
import { Link } from "react-router-dom";
import items from "../images/items.png";
import add from "../images/additem.png";
import remove from "../images/removeitems.png";
import counterpart from "counterpart";
import eng from "../lang/eng";
import urdu from "../lang/urdu";

counterpart.registerTranslations("eng", eng);
counterpart.registerTranslations("urdu", urdu);

counterpart.setLocale("eng");

class Cards extends Component {
  componentWillMount() {
    counterpart.setLocale(this.props.lang);
    localStorage.removeItem("selectedToSale");
    localStorage.removeItem("items");
    localStorage.removeItem("itemsForSearch");
  }

  render() {
    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("tokenType") != "user"
    ) {
      window.location.reload();
    }
    return (
      <div className="center">
        <div className="Title">
          <h1>WELCOME TO {localStorage.getItem("company").toUpperCase()} </h1>
          <h2>DASHBOARD</h2>
        </div>

        <div className="cards">
          <Link to="/inventory/dashboard/incoming">
            <button variant="contained" color="primary" className="card">
              <img className="imgicon" src={add} alt="add-img"></img>
              <h1 className="btntext">Add</h1>
            </button>
          </Link>

          <Link to="/inventory/dashboard/outgoing">
            <button variant="contained" color="primary" className="card">
              <img className="imgicon" src={remove} alt="remove-img"></img>
              <h1 className="btntext">Sale</h1>
            </button>
          </Link>

          <Link className="Link" to="/inventory/dashboard/items">
            <button variant="contained" color="primary" className="card">
              <img className="imgicon" src={items} alt="items-img"></img>
              <h1 className="btntext">Items</h1>
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export { Cards };
